import { Control, FieldValues } from 'react-hook-form';

import { Indicator, Input, Toggle } from './toggleSwitchStyle';
import ToggleSwitchWithController from './ToggleSwitchWithController';

interface IProps {
  value?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  id?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  required?: boolean;
  name?: string;
  control?: Control<FieldValues, object>;
  isLoading?: boolean;
}

const ToggleSwitchView = ({
  value,
  defaultChecked,
  checked,
  disabled,
  onChange,
  id,
  name,
  control,
  isLoading = false,
}: IProps) => {
  const input = control ? (
    <ToggleSwitchWithController
      control={control}
      name={name}
      id={id}
      value={value}
      defaultChecked={defaultChecked}
      checked={checked}
      onChange={onChange}
      disabled={disabled || isLoading}
    />
  ) : (
    <Input
      name={name}
      type="checkbox"
      id={id}
      value={value}
      defaultChecked={defaultChecked}
      checked={checked}
      onChange={onChange}
      disabled={disabled || isLoading}
    />
  );

  return (
    <Toggle disabled={disabled || isLoading} isLoading={isLoading}>
      {input}
      <Indicator />
    </Toggle>
  );
};

export default ToggleSwitchView;
